import axios from 'axios';
import moment from 'moment';
export default {
    name: 'booking_customer_details',
    components: {
    },
    data() {
        return{
            url: 'https://' + window.location.hostname + '/index.php/',
            cust_details: [],
            customer_bookings_details: [],
            edit_customer_notes: false,
            show_client_info: false,
            show_payment_info: true,
            pay_full: false,
            text_on_button: '',
            take_wallet: false,
            wallet_amount: 0,
            payment_type: 1,
            hide_fields: true,
            send_mail: false,
            send_text: false,
            alt_image: '',
            payable_amount: 0,
            total_amount: 0,
            clickable: false,
            show_deposit: false,
            flag: 'deposit',
            selected_wallet: false,
            first_loading_count:0,
        }
    },
    props: ["total", "deposite", "cust_id", "book_id", "multi_book_id", "booking_date"],
    filters: {
        human_date_format: function (date) {
            return moment(date).format('DD MMM YYYY, hh:mm A');
        },
        uppercase: function (name) {
            if (name){
                return name.toUpperCase();
            }
        }
    },

    computed: {
        check_balance_due() {
            if(this.first_loading_count === 2 && this.deposite < 1){
                this.show_deposit = true;
                this.flag = "total";
            }
            if (this.flag === "deposit") {
                this.payable_amount = parseFloat(this.deposite).toFixed(2);
            } else {
                this.payable_amount = parseFloat(this.total).toFixed(2);
            }
            this.total_amount = parseFloat(this.total).toFixed(2);
            this.first_loading_count++;
            this.checkWallet();
        }
    },

    created() {
        this.get_customer_details();
        this.$session.remove('has_products_in_page');
    },

    methods: {
        get_customer_details() {
            this.$emit('show_popover');
            axios.post(this.$store.state.api + `get_details_of_customer`, {
                "owner_id": this.$session.get('owner_id'),
                "cust_id": this.cust_id
            }).then(response => {
                this.cust_details = response.data.result.customer_details[0];
                if (!this.cust_details.cust_picture || (this.cust_details.cust_picture == 'null'))
                    this.cust_details.cust_picture = '';
                this.alt_image = this.cust_details.cust_first_name[0] ? this.cust_details.cust_first_name[0] : '' + '' + this.cust_details.cust_last_name[0] ? this.cust_details.cust_last_name[0] : '';
                this.customer_bookings_details = response.data.result;
                //this.payable_amount = this.deposite;
                this.$emit('close_popover');                
                this.get_wallet_amount();   
            })
        },

        get_wallet_amount() {
            axios.post(this.$store.state.api + `transactions/get_customer_store_wallet`, {
                "store_id": this.$session.get('store_id'),
                "cust_id": this.cust_id
            }).then(response => {
                this.wallet_amount = response.data.wallet[0].amount.toFixed(2);
                if (this.wallet_amount == 0)
                    document.getElementById('wallet_checkbox').disabled = true;
            })
        },

        view_payment() {
            this.show_payment_info = false;
            this.show_client_info = true;
        },

        view_cust_details() {
            this.show_payment_info = true;
            this.show_client_info = false;
        },

        async update_customer_notes() {
            await this.$store.dispatch('update_customer_notes', [this.$store.state.api, this.cust_details.cust_id, this.$store.state.user_id, this.cust_details.cust_notes, this.$store.state.user_id])
            if (this.cust_details.cust_notes.length != 0) {
                this.$refs.edit_cust_notes.innerHTML = 'Saved';
                this.$refs.edit_cust_notes.style.cssText = "background: #10A377 !important";
            }
            this.save_cust_notes();
        },

        edit_cust_notes() {
            this.edit_customer_notes = true;
            let _this = this;
            setTimeout(function () {
                _this.$refs.cust_notes.focus();
            }, 100);
        },

        save_cust_notes() {
            let _this = this;
            setTimeout(function () {
                _this.edit_customer_notes = false;
            }, 700);

        },

        amount_change(type) {
            if (type == "amount") {
                this.$refs.total_amount_input.className = "form-control payable_amount font-weight-bold d-none";
                this.$refs.total_amount.className = " form-control payable_amount font-weight-bold";
            } else {
                this.$refs.total_amount.className = " form-control payable_amount font-weight-bold d-none";
                this.$refs.total_amount_input.className = "form-control payable_amount font-weight-bold";
                this.$refs.total_amount_input.select();
            }
        },

        change_payable_amount(type) {
            if (type == 'balance' || type == 'deposit') {
                if (type == 'balance') {
                    this.show_deposit = true;
                    this.payable_amount = this.total;
                    this.flag = "total";
                } else {
                    this.show_deposit = false;
                    this.payable_amount = this.deposite;
                    this.flag = "deposit";
                }

            }

            if (type == 'check_box') {
                this.selected_wallet = !this.take_wallet;
                
                if (this.selected_wallet) {
                    if (this.flag == "deposit") {
                        var deposit_amount = (parseFloat(this.deposite) - parseFloat(this.wallet_amount)).toFixed(2);
                        if (deposit_amount < 0) {
                            this.payable_amount = 0.00;
                        } else {
                            this.payable_amount = parseFloat(deposit_amount).toFixed(2);
                        }
                    } else if (this.flag == "total") {
                        this.payable_amount = (parseFloat(this.total) - parseFloat(this.wallet_amount)).toFixed(2);
                    }

                } else {
                    if (this.flag == "deposit") {
                        this.payable_amount = this.deposite;

                    } else if (this.flag == "total") {
                        this.payable_amount = this.total;
                    }
                }
            } else
                this.selected_wallet = this.take_wallet;

            this.hide_fields = true;
        },

        checkWallet() {
            if (this.selected_wallet) {
                if (this.flag == "deposit") {
                    var deposit = (parseFloat(this.deposite) - parseFloat(this.wallet_amount)).toFixed(2);
                    if (deposit < 0) {
                        this.payable_amount = 0.00;
                    } else {
                        this.payable_amount = parseFloat(deposit).toFixed(2);
                    }
                } else if (this.flag == "total") {
                    this.payable_amount = (parseFloat(this.total) - parseFloat(this.wallet_amount)).toFixed(2);
                }
            }
        },

        pay_now() {
            var pos = 0;
            var cash = 0;
            var make_payment = false;
            if (this.hide_fields) {
                if (this.payment_type == 1) {
                    pos = 0;
                    cash = 1;
                    make_payment = true;
                } else if (this.payment_type == 2) {
                    pos = 1;
                    cash = 1;
                    make_payment = true;
                } else
                    make_payment = false;
            } else
                make_payment = true;


            if (make_payment) {
                this.$emit('show_popover');
                axios.post(this.$store.state.api + 'transactions/insert_bookings_payment_amount_v2', {
                    "book_id": this.book_id,
                    "multi_book_id": this.multi_book_id,
                    "pay_deposit": parseFloat(this.deposite).toFixed(2),
                    "pay_fullamount": parseFloat(this.total).toFixed(2),
                    "store_id": this.$session.get('store_id'),
                    "cust_id": this.cust_id,
                    "wallet": this.take_wallet,
                    "cash_pay": cash,
                    "pay_amount": parseFloat(this.payable_amount),
                    "cust_email": this.cust_details.cust_email,
                    "pos_pay": pos
                }).then(response => {
                    this.$store.state.selected_date = moment(this.booking_date).format('yyyy-MM-DD');
                    if ((this.$session.get('toast_title') != 'Booking Updated') && (this.$session.get('toast_title') != 'Reschedule Successful')) {
                        this.$session.set('toast_message', 'Booking successfull with payment');
                    }
                    this.$session.set('show_toast', true);
                    this.$session.set('book_id', this.book_id)
                    this.$session.set('multi_book_id', this.multi_book_id)
                    this.$router.push('/viewbooking')
                    this.$emit('close_popover');

                    console.log(response.data.status);
                })
            } else
                alert("Please select the payment type");
        }
    }
}